import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ConnectionMonitor = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isApiConnected, setIsApiConnected] = useState(true);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    const checkApi = async () => {
      try {
        const res = await fetch(`${API_URL}/api/health`, { method: 'GET' });
        const connected = res.ok;
        setIsApiConnected(prev => {
          if (!prev && connected) setShowStatus(true);
          if (prev && !connected) setShowStatus(true);
          return connected;
        });
      } catch {
        setIsApiConnected(prev => {
          if (prev) setShowStatus(true);
          return false;
        });
      }
    };

    checkApi();
    const interval = setInterval(checkApi, 15000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(interval);
    };
  }, []);

  const isConnected = isOnline && isApiConnected;

  useEffect(() => {
    if (isConnected && showStatus) {
      const timer = setTimeout(() => setShowStatus(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [isConnected, showStatus]);

  if (!isConnected || showStatus) {
    return (
      <div
        className={`fixed bottom-4 right-4 z-50 px-4 py-3 rounded-lg shadow-lg flex items-center space-x-3 ${
          isConnected ? 'bg-green-600 text-white' : 'bg-red-600 text-white animate-pulse'
        }`}
      >
        {isConnected ? (
          <>
            <Wifi className="h-5 w-5" />
            <span className="font-semibold">Connected</span>
          </>
        ) : (
          <>
            <WifiOff className="h-5 w-5" />
            <div>
              <p className="font-semibold">Connection Lost</p>
              <p className="text-xs opacity-90">Attempting to reconnect...</p>
            </div>
          </>
        )}
      </div>
    );
  }

  return null;
};

export default ConnectionMonitor;
